var _g, _rect, _rect2, _g2, _g3, _rect3, _rect4, _g4, _g5, _rect5, _rect6, _g6, _g7, _rect7, _rect8, _g8, _g9, _rect9, _rect10, _g10, _g11, _rect11, _rect12, _g12, _circle, _circle2, _circle3, _circle4, _g13, _circle5, _circle6, _g14, _g15, _circle7, _circle8, _g16, _g17, _circle9, _circle10, _g18, _g19, _circle11, _circle12, _g20, _g21, _circle13, _circle14, _g22, _g23, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoleculeModel3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 234,
    viewBox: "0 0 236 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_681_4124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.234,
    y: 25.2949,
    width: 36.7186,
    height: 1.63194,
    transform: "rotate(-180 146.234 25.2949)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.234,
    y: 25.2949,
    width: 36.7186,
    height: 1.63194,
    transform: "rotate(-180 146.234 25.2949)",
    fill: "url(#paint0_radial_681_4124)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 154.398,
    y: 26.9272,
    width: 53.0379,
    height: 4.89581,
    rx: 2.4479,
    transform: "rotate(-180 154.398 26.9272)",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 154.398,
    y: 26.9272,
    width: 53.0379,
    height: 4.89581,
    rx: 2.4479,
    transform: "rotate(-180 154.398 26.9272)",
    fill: "url(#paint1_radial_681_4124)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_681_4124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.398,
    y: 26.9272,
    width: 53.0379,
    height: 4.89581,
    transform: "rotate(-180 154.398 26.9272)",
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_681_4124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.9766,
    y: 42.1611,
    width: 48.6719,
    height: 1.63194,
    transform: "rotate(124.856 70.9766 42.1611)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.9766,
    y: 42.1611,
    width: 48.6719,
    height: 1.63194,
    transform: "rotate(124.856 70.9766 42.1611)",
    fill: "url(#paint2_radial_681_4124)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 34.2192,
    width: 70.3038,
    height: 4.89581,
    rx: 2.4479,
    transform: "rotate(124.856 78.5 34.2192)",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 34.2192,
    width: 70.3038,
    height: 4.89581,
    rx: 2.4479,
    transform: "rotate(124.856 78.5 34.2192)",
    fill: "url(#paint3_radial_681_4124)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_681_4124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 34.2192,
    width: 70.3038,
    height: 4.89581,
    transform: "rotate(124.856 78.5 34.2192)",
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_681_4124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.1328,
    y: 122.733,
    width: 42.49,
    height: 1.63194,
    transform: "rotate(66.6064 44.1328 122.733)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.1328,
    y: 122.733,
    width: 42.49,
    height: 1.63194,
    transform: "rotate(66.6064 44.1328 122.733)",
    fill: "url(#paint4_radial_681_4124)"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 41.8906,
    y: 113.42,
    width: 61.3745,
    height: 4.89581,
    rx: 2.4479,
    transform: "rotate(66.6064 41.8906 113.42)",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 41.8906,
    y: 113.42,
    width: 61.3745,
    height: 4.89581,
    rx: 2.4479,
    transform: "rotate(66.6064 41.8906 113.42)",
    fill: "url(#paint5_radial_681_4124)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_b_681_4124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.8906,
    y: 113.42,
    width: 61.3745,
    height: 4.89581,
    transform: "rotate(66.6064 41.8906 113.42)",
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_681_4124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.703,
    y: 189.025,
    width: 47.7332,
    height: 1.63194,
    transform: "rotate(-0.571666 108.703 189.025)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.703,
    y: 189.025,
    width: 47.7332,
    height: 1.63194,
    transform: "rotate(-0.571666 108.703 189.025)",
    fill: "url(#paint6_radial_681_4124)"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 98.0859,
    y: 187.498,
    width: 68.9479,
    height: 4.89581,
    rx: 2.4479,
    transform: "rotate(-0.571666 98.0859 187.498)",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 98.0859,
    y: 187.498,
    width: 68.9479,
    height: 4.89581,
    rx: 2.4479,
    transform: "rotate(-0.571666 98.0859 187.498)",
    fill: "url(#paint7_radial_681_4124)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_b_681_4124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.0859,
    y: 187.498,
    width: 68.9479,
    height: 4.89581,
    transform: "rotate(-0.571666 98.0859 187.498)",
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_681_4124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.359,
    y: 158.697,
    width: 47.7332,
    height: 1.63194,
    transform: "rotate(-62.7683 184.359 158.697)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.359,
    y: 158.697,
    width: 47.7332,
    height: 1.63194,
    transform: "rotate(-62.7683 184.359 158.697)",
    fill: "url(#paint8_radial_681_4124)"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 178.055,
    y: 167.381,
    width: 68.9479,
    height: 4.89581,
    rx: 2.4479,
    transform: "rotate(-62.7683 178.055 167.381)",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 178.055,
    y: 167.381,
    width: 68.9479,
    height: 4.89581,
    rx: 2.4479,
    transform: "rotate(-62.7683 178.055 167.381)",
    fill: "url(#paint9_radial_681_4124)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_b_681_4124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.055,
    y: 167.381,
    width: 68.9479,
    height: 4.89581,
    transform: "rotate(-62.7683 178.055 167.381)",
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_681_4124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 202.852,
    y: 85.8407,
    width: 49.2692,
    height: 1.63194,
    transform: "rotate(-121.977 202.852 85.8407)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.852,
    y: 85.8407,
    width: 49.2692,
    height: 1.63194,
    transform: "rotate(-121.977 202.852 85.8407)",
    fill: "url(#paint10_radial_681_4124)"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 207.273,
    y: 95.9924,
    width: 71.1666,
    height: 4.89581,
    rx: 2.4479,
    transform: "rotate(-121.977 207.273 95.9924)",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 207.273,
    y: 95.9924,
    width: 71.1666,
    height: 4.89581,
    rx: 2.4479,
    transform: "rotate(-121.977 207.273 95.9924)",
    fill: "url(#paint11_radial_681_4124)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_b_681_4124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.273,
    y: 95.9924,
    width: 71.1666,
    height: 4.89581,
    transform: "rotate(-121.977 207.273 95.9924)",
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3194,
    cy: 16.3194,
    r: 16.3194,
    transform: "matrix(-1 0 0 1 182.141 9.7916)",
    fill: "#AABFA7",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3194,
    cy: 16.3194,
    r: 16.3194,
    transform: "matrix(-1 0 0 1 182.141 9.7916)",
    fill: "url(#paint12_radial_681_4124)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.7517,
    cy: 7.7517,
    r: 7.7517,
    transform: "matrix(-1 0 0 1 173.977 17.9509)",
    fill: "#B2B2B2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.7517,
    cy: 7.7517,
    r: 7.7517,
    transform: "matrix(-1 0 0 1 173.977 17.9509)",
    fill: "url(#paint13_radial_681_4124)"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_b_681_4124)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.3194,
    cy: 16.3194,
    r: 16.3194,
    transform: "matrix(-1 0 0 1 182.141 9.7916)",
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.479,
    cy: 24.479,
    r: 24.479,
    transform: "matrix(-1 0 0 1 107.062 0)",
    fill: "#AABFA7",
    fillOpacity: 0.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.479,
    cy: 24.479,
    r: 24.479,
    transform: "matrix(-1 0 0 1 107.062 0)",
    fill: "url(#paint14_radial_681_4124)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_681_4124)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.38363,
    cy: 9.38363,
    r: 9.38363,
    transform: "matrix(-1 0 0 1 91.5547 15.503)",
    fill: "#FFBE7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.38363,
    cy: 9.38363,
    r: 9.38363,
    transform: "matrix(-1 0 0 1 91.5547 15.503)",
    fill: "url(#paint15_radial_681_4124)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_b_681_4124)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.479,
    cy: 24.479,
    r: 24.479,
    transform: "matrix(-1 0 0 1 107.062 0)",
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5589,
    cy: 28.5589,
    r: 28.5589,
    transform: "matrix(-1 0 0 1 201.391 153.402)",
    fill: "#AABFA7",
    fillOpacity: 0.2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5589,
    cy: 28.5589,
    r: 28.5589,
    transform: "matrix(-1 0 0 1 201.391 153.402)",
    fill: "url(#paint16_radial_681_4124)"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_681_4124)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.0555,
    cy: 13.0555,
    r: 13.0555,
    transform: "matrix(-1 0 0 1 185.406 169.721)",
    fill: "#45756E",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.0555,
    cy: 13.0555,
    r: 13.0555,
    transform: "matrix(-1 0 0 1 185.406 169.721)",
    fill: "url(#paint17_radial_681_4124)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_b_681_4124)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.5589,
    cy: 28.5589,
    r: 28.5589,
    transform: "matrix(-1 0 0 1 201.391 153.402)",
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7984,
    cy: 40.7984,
    r: 40.7984,
    transform: "matrix(-1 0 0 1 114.406 151.775)",
    fill: "#FFBE7F",
    fillOpacity: 0.2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7984,
    cy: 40.7984,
    r: 40.7984,
    transform: "matrix(-1 0 0 1 114.406 151.775)",
    fill: "url(#paint18_radial_681_4124)"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_681_4124)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.1353,
    cy: 16.7273,
    rx: 17.1353,
    ry: 16.7273,
    transform: "matrix(-1 0 0 1 92.375 173.806)",
    fill: "#FFBE7F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.1353,
    cy: 16.7273,
    rx: 17.1353,
    ry: 16.7273,
    transform: "matrix(-1 0 0 1 92.375 173.806)",
    fill: "url(#paint19_radial_681_4124)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_b_681_4124)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.7984,
    cy: 40.7984,
    r: 40.7984,
    transform: "matrix(-1 0 0 1 114.406 151.775)",
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.6387,
    cy: 32.6387,
    r: 32.6387,
    transform: "matrix(-1 0 0 1 66.2734 73.4423)",
    fill: "#AABFA7"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.6387,
    cy: 32.6387,
    r: 32.6387,
    transform: "matrix(-1 0 0 1 66.2734 73.4423)",
    fill: "url(#paint20_radial_681_4124)"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_681_4124)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.5034,
    cy: 15.5034,
    r: 15.5034,
    transform: "matrix(-1 0 0 1 46.6875 91.3932)",
    fill: "#45756E",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5034,
    cy: 15.5034,
    r: 15.5034,
    transform: "matrix(-1 0 0 1 46.6875 91.3932)",
    fill: "url(#paint21_radial_681_4124)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_b_681_4124)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.6387,
    cy: 32.6387,
    r: 32.6387,
    transform: "matrix(-1 0 0 1 66.2734 73.4423)",
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.479,
    cy: 24.479,
    r: 24.479,
    transform: "matrix(-1 0 0 1 235.992 76.701)",
    fill: "#AABFA7"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.479,
    cy: 24.479,
    r: 24.479,
    transform: "matrix(-1 0 0 1 235.992 76.701)",
    fill: "url(#paint22_radial_681_4124)"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_f_681_4124)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.8315,
    cy: 11.8315,
    r: 11.8315,
    transform: "matrix(-1 0 0 1 223.758 89.7562)",
    fill: "#FFBE7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.8315,
    cy: 11.8315,
    r: 11.8315,
    transform: "matrix(-1 0 0 1 223.758 89.7562)",
    fill: "url(#paint23_radial_681_4124)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_b_681_4124)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.479,
    cy: 24.479,
    r: 24.479,
    transform: "matrix(-1 0 0 1 235.992 76.701)",
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_681_4124",
    x: 105.516,
    y: 19.663,
    width: 44.7188,
    height: 9.63193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_681_4124"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_681_4124",
    x: 96.3594,
    y: 17.0314,
    width: 63.0391,
    height: 14.8958,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_681_4124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_681_4124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_681_4124",
    x: 37.8203,
    y: 37.2284,
    width: 37.1562,
    height: 48.8726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_681_4124"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_681_4124",
    x: 29.3047,
    y: 26.4212,
    width: 54.1953,
    height: 70.489,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_681_4124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_681_4124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_681_4124",
    x: 38.6328,
    y: 118.733,
    width: 26.3672,
    height: 47.6453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_681_4124"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_681_4124",
    x: 32.3984,
    y: 108.42,
    width: 38.8594,
    height: 68.2733,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_681_4124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_681_4124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_681_4124",
    x: 104.703,
    y: 184.549,
    width: 55.75,
    height: 10.1081,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_681_4124"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_b_681_4124",
    x: 93.0859,
    y: 181.81,
    width: 78.9922,
    height: 15.5835,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_681_4124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_681_4124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_681_4124",
    x: 180.359,
    y: 112.255,
    width: 31.2969,
    height: 51.1893,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_681_4124"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_b_681_4124",
    x: 173.055,
    y: 101.075,
    width: 45.9062,
    height: 73.5462,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_681_4124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_681_4124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_681_4124",
    x: 172.758,
    y: 39.1836,
    width: 35.4766,
    height: 50.6571,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_681_4124"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_b_681_4124",
    x: 164.586,
    y: 28.0321,
    width: 51.8438,
    height: 72.9603,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_681_4124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_681_4124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_b_681_4124",
    x: 144.5,
    y: 4.7916,
    width: 42.6406,
    height: 42.6387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_681_4124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_681_4124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_681_4124",
    x: 62.7891,
    y: 5.50302,
    width: 38.7656,
    height: 38.7673,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_681_4124"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_b_681_4124",
    x: 53.1016,
    y: -5,
    width: 58.9609,
    height: 58.9581,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_681_4124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_681_4124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_681_4124",
    x: 149.297,
    y: 159.721,
    width: 46.1094,
    height: 46.111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_681_4124"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_b_681_4124",
    x: 139.273,
    y: 148.402,
    width: 67.1172,
    height: 67.1177,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_681_4124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_681_4124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_681_4124",
    x: 48.1016,
    y: 163.806,
    width: 54.2734,
    height: 53.4547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_681_4124"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_b_681_4124",
    x: 27.8125,
    y: 146.775,
    width: 91.5938,
    height: 91.5968,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_681_4124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_681_4124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_681_4124",
    x: 5.67969,
    y: 81.3932,
    width: 51.0078,
    height: 51.0068,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_681_4124"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_b_681_4124",
    x: -4.00781,
    y: 68.4423,
    width: 75.2812,
    height: 75.2775,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_681_4124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_681_4124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_681_4124",
    x: 190.094,
    y: 79.7562,
    width: 43.6641,
    height: 43.6631,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_681_4124"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_b_681_4124",
    x: 182.031,
    y: 71.701,
    width: 58.9609,
    height: 58.9581,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_681_4124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_681_4124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(150.155 25.0142) rotate(4.61585) scale(24.3427 2.17753)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(169.394 28.3981) rotate(5.12335) scale(30.1118 5.52335)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.174 41.8804) rotate(3.48549) scale(32.2222 2.18058)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.3774 35.6901) rotate(3.86955) scale(39.8457 5.53286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.6701 122.452) rotate(3.99107) scale(28.1458 2.17932)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.2434 114.891) rotate(4.43043) scale(34.8096 5.52893)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.8 188.744) rotate(3.55387) scale(31.603 2.18042)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117.58 188.969) rotate(3.94541) scale(39.0808 5.53236)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(189.457 158.417) rotate(3.55387) scale(31.603 2.18042)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.549 168.852) rotate(3.94541) scale(39.0808 5.53236)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(208.113 85.56) rotate(3.44334) scale(32.6161 2.18067)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(227.395 97.4633) rotate(3.82278) scale(40.3325 5.53316)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.22815 9.806) rotate(44.1659) scale(25.7293 26.5195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.65552 -2.66626) rotate(61.1678) scale(21.2437 10.0085)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8422 14.709) rotate(44.1659) scale(38.594 39.7793)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.00405 -3.22758) rotate(61.1678) scale(25.7161 12.1155)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1493 17.1605) rotate(44.1659) scale(45.0263 46.4092)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.78825 -4.49055) rotate(61.1678) scale(35.7789 16.8564)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0704 24.515) rotate(44.1659) scale(64.3233 66.2989)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.65958 -5.75351) rotate(60.5808) scale(46.1041 21.998)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.4563 19.612) rotate(44.1659) scale(51.4586 53.0391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.31105 -5.33252) rotate(61.1678) scale(42.4874 20.0169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8422 14.709) rotate(44.1659) scale(38.594 39.7793)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_681_4124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.52685 -4.06956) rotate(61.1678) scale(32.4246 15.2761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoleculeModel3);
export default __webpack_public_path__ + "static/media/molecule-model-3.39ff29d627e60dfa6a644af7079da599.svg";
export { ForwardRef as ReactComponent };